import { get } from 'lib/httpClient';
import { fetchWithCache } from 'lib/apiCache';

const SCHEDULE_CACHE_KEY = '/schedule/retrieve';

const retrieve_schedule = async (
  callback: ((data: any) => void) | null = null,
  options: { forceRefresh?: boolean } = {}
): Promise<void> => {
  const { forceRefresh = false } = options;
  const path = SCHEDULE_CACHE_KEY;
  const result = await fetchWithCache(path, () => get(path), forceRefresh);
  console.debug('retrieve_schedule', result?.data);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { retrieve_schedule };
